// extracted by mini-css-extract-plugin
export default {"Wrapper":"Layout_Wrapper__DVjhj","Navcontainer":"Layout_Navcontainer__6Wh6Q","nav-hide":"Layout_nav-hide__VZQqp","main-content":"Layout_main-content__3OR9J"};